export enum UsersOrganizationsPermissionsReadType{
    IsOwner = 1,
    ClosedParties = 2,
    RevenuesRead = 1 << 2,
    ExpensesRead = 1 << 3,
    DonationRead = 1 << 4,
    SponsorsRead = 1 << 5,
    EventsRead = 1 << 6,
    PartyNotesRead = 1 << 7,
    BarsRead = 1 << 8,
    DashboardRead = 1 << 9,
}
